module.exports = __webpack_public_path__ + "static/media/esafaru-card@2x.f242a583.png";